const { createContext } = require("react");

const PedidosContext = createContext();

export default PedidosContext;
